import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FireBaseObjectNames } from '../../../core/codes';
import { AngularFireDatabaseWrapper } from '../../../providers/angularfire-wrapper';
import  * as Rx  from 'rxjs';

import _ from 'lodash';

@Injectable()
export class HomeData {

    constructor(
        public afw: AngularFireDatabaseWrapper 
        ) {
    }

    public getHomePageWidgets () {
        var self = this;
        
        return Observable.create((observer)=>{
            self.afw.list(FireBaseObjectNames.PAGE_SECTIONS + '/home', undefined).map(sections => {
                sections = sections ? _.sortBy(sections, 'order') : [];

                let reads = [];
                _.forEach(sections, (widget) => {
                    if(widget.widgetId){
                        let obs = Observable.create((observer1) =>{
                            self.afw.object(FireBaseObjectNames.PAGE_WIDGETS + '/' + widget.widgetId, undefined, true).map((w) => {
                                console.log(w.status === 'Publish');
                                if (w.status === 'Publish') {
                                    if (w.type === 'slider') {
                                        if (w.data.full) w.data.full = _.values(w.data.full);
                                        if (w.data.mobile) w.data.mobile = _.values(w.data.mobile);
                                    } else if (w.type === 'recipe-features') {
                                        if (w.data) w.data = _.values(w.data);
                                    }
                                    
                                    observer1.next(w);
                                } else {
                                    observer1.next({});
                                }

                                observer1.complete();
                            }).subscribe();
                        });
                         
                        reads.push(obs);
                    }
                });

                Rx.Observable.forkJoin(reads).subscribe(widgets=>{
                    observer.next(widgets);
                });
            }).subscribe();
        }) 
    }
}


// WEBPACK FOOTER //
// ./src/modules/home/providers/home-data.ts